import { forwardRef } from 'react'

import { Heading, MediaQueries } from '@hhgtech/hhg-components'
import { Avatar } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, Flex, Stack, Text } from '@mantine/core'

import { useIsMobile } from 'hooks/useIsMobile'
import {
  DEFAULT_AVATAR_IMG,
  assetImagePath,
  assetSvgPath,
} from 'interfaces/constants'
import { useExpertStore } from 'state/expert'

import { StyledInfoContainer, StyledSocialIcon } from './index.styled'
const socialMediaKeys = [
  'url',
  'facebook',
  'instagram',
  'linkedin',
  'myspace',
  'pinterest',
  'soundcloud',
  'tumblr',
  'twitter',
  'youtube',
  'wikipedia',
  'tiktok',
]
export const _Information = forwardRef<HTMLDivElement, BoxProps>(
  function __Information({ ...rest }, ref) {
    const { currentExpert: expert } = useExpertStore((state) => ({
      currentExpert: state.currentExpert,
    }))
    const isMobile = useIsMobile()
    if (!expert) return null
    return (
      <Box {...rest}>
        <StyledInfoContainer>
          <Flex
            ref={ref}
            gap={{ base: 16, md: 40 }}
            h="fit-content"
            direction={{ base: 'column', md: 'row' }}
            ta={{ base: 'center', md: 'left' }}
            sx={{
              transform: 'translateY(20%)',
              [MediaQueries.mbUp]: {
                transform: 'translateY(30%)',
              },
            }}
          >
            <div>
              <Avatar
                sx={{
                  border: '4px solid #ffffff',
                }}
                bg="#ffffff"
                size={isMobile ? 100 : 168}
                radius={'100%'}
                pos={'relative'}
                src={
                  expert.avatarThumbnail || expert.avatar || DEFAULT_AVATAR_IMG
                }
                withIndicator={!!expert.role}
                indicatorConfig={
                  expert.role
                    ? {
                        offset: isMobile ? 14 : 20,
                        size: isMobile ? 18 : 40,
                        label: (
                          <img
                            width={isMobile ? '18' : '40'}
                            height={isMobile ? '18' : '40'}
                            src={`${assetImagePath}/article-${expert.role}.svg`}
                            alt=""
                            loading="lazy"
                          />
                        ),
                      }
                    : undefined
                }
              />
            </div>
            <Stack
              maw={568}
              justify="flex-end"
              spacing={isMobile ? 6 : 8}
              px={{ base: 16, md: 0 }}
            >
              <Heading tag="h3" as="h1">
                {expert.displayName}
              </Heading>
              <Text size="p3">
                {expert.fields.specialty && (
                  <Text span inherit>
                    {expert.fields.specialty}
                  </Text>
                )}
                {expert.fields.organisation && (
                  <Text span inherit>
                    {' '}
                    ·{' '}
                    {expert.organisationUrl ? (
                      <a
                        href={expert.organisationUrl}
                        target="_blank"
                        style={{ textDecoration: 'underline' }}
                      >
                        {expert.fields.organisation}
                      </a>
                    ) : (
                      expert.fields.organisation
                    )}
                  </Text>
                )}
              </Text>
              <Flex gap={16} justify={isMobile ? 'center' : 'start'}>
                {socialMediaKeys.map((key, index) => {
                  const contact = expert.fields?.contact
                  const currentContact = contact?.[key as keyof typeof contact]
                  if (!currentContact) return null

                  return (
                    <StyledSocialIcon
                      key={index}
                      href={currentContact || ''}
                      className="no-replace-click"
                      target="_blank"
                    >
                      <img
                        src={`${assetSvgPath}/${key}.svg`}
                        className="social-icons"
                        alt=""
                        loading="lazy"
                      />
                    </StyledSocialIcon>
                  )
                })}
              </Flex>
            </Stack>
          </Flex>
        </StyledInfoContainer>
      </Box>
    )
  },
)
